import InputArray from "components/InputArray";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface SkillsFormProps {
  selected: string[];
  setSelected: Dispatch<SetStateAction<string[]>>;
}

const Wrapper = styled.div`
  width: 100%;
`;

const Text = styled.h2`
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 1.8rem;
`;

const InterestsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 24px 20px;
`;

const SkillsForm = ({ selected, setSelected }: SkillsFormProps) => {
  const { t } = useTranslation("forms");

  const removeEntry = (target: string) => {
    setSelected((prevState) => prevState.filter((entry) => entry !== target));
  };

  return (
    <Wrapper>
      <Text>{t("chooseSkills")}</Text>
      <InterestsWrapper>
        <InputArray
          placeholder={t("addSkill")}
          entries={selected}
          addEntry={(value: string) => {
            setSelected((prevState) => [value, ...prevState]);
          }}
          removeEntry={removeEntry}
        />
      </InterestsWrapper>
    </Wrapper>
  );
};

export default SkillsForm;
